import s from './bi/state'
import * as a from './bi/actions'
import * as m from './bi/mutations'
import * as g from './bi/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
